import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=4c26726a&lang=pug"
import script from "./thumbnail.vue?vue&type=script&lang=js"
export * from "./thumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports